import {
  cancelContactOrdersBatch,
  completeContactOrdersBatch,
} from "../../../../../../../../../../api/kehrblatt/contact-orders"
import type { AnnouncementPlanOperations } from "../actions/announcementPlans"

export const announcementPlanOperations: AnnouncementPlanOperations = {
  cancel: cancelContactOrdersBatch,
  complete: completeContactOrdersBatch,
}
